import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export class ColumnSortService {

  private sortColumnSource = new Subject<ColumnSortEvent>();

  public sortColumn$: Observable<ColumnSortEvent> = this.sortColumnSource.asObservable();

  constructor() { }

  public sortByColumn(event: ColumnSortEvent) {
    this.sortColumnSource.next(event);
  }
}

export interface ColumnSortEvent {
  sortColumn: string;
  sortDirection: string;
  dataType?: string;
}